module.exports = __webpack_public_path__ + "static/media/book2.64e88d72.pdf";